import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import {
    updateControlArea,
    updateDeliveryNoteTouched,
    addControlArea,
    getSupplierSuggestions
} from './actions'
import Control from './area';
import { semanticColors, greyScaleColors } from '../../../../Globals/styles';
import { isStringValid } from '../../../../Util/stringValidator'

class ControlAreas extends Component {
    addControlArea = (index) => {
        if (index === this.props.controlAreas.length - 1) {
            this.props.dispatch(addControlArea());
        }
    };
    isContainerActive = () => {
        const { controlAreas } = this.props;
        for (let i = 0; i < controlAreas.length; i++) {
            if (controlAreas[i].type || controlAreas[i].area)
                return true
        }
        return false
    };
    getTypeSelectPickerChildren = () => {
        let selectpickerChildren = [];
        this.props.suggestions.forEach((type, index) => {
            if (index === 0) {
                selectpickerChildren.push(
                    <option
                        key={index}
                        value={0}>
                        Intet valgt
              </option>
                )
            }
            selectpickerChildren.push(
                <option
                    key={index + 1}
                    value={type}>
                    {type}
                </option>
            )
        })
        return selectpickerChildren
    };
    render() {
        const { controlAreas, dispatch, suggestions } = this.props;
        let isAllValid = true;
        let selections = this.getTypeSelectPickerChildren()
        let controlAreaNodes = controlAreas.map((controlArea, index) => {
            return (
                <Control
                key={index}
                    controlArea={controlArea}
                    updateControlArea={(type, val) => {
                        dispatch(updateControlArea(type, index, val))
                        this.addControlArea(index)
                    }}
                    suggestions={selections}
                />
            )
        })

        return (
            <div style={styles.outerContainer}>
                <div className="row" style={[styles.container, this.isContainerActive() && styles.containerActive, !isAllValid && styles.containerError]}>
                    <div style={styles.heading}>
                        Kontrol
                    </div>
                    <div style={{ height: '38px' }}>
                        <div style={[styles.colHeading, { display: 'inline-block', width: '15%' }]}>Type</div>
                        <div style={[styles.colHeading, { display: 'inline-block', width: '13%' }]}>Temp C&deg;</div>
                        <div style={[styles.colHeading, { display: 'inline-block', width: '12%' }]} >Revnevidde mm</div>
                        <div style={[styles.colHeading, { display: 'inline-block', width: '12%' }]} >Mat. kontrol min.</div>
                        <div style={[styles.colHeading, { display: 'inline-block', width: '9%' }]} >Rf %</div>
                        <div style={[styles.colHeading, { display: 'inline-block', width: '11%' }]} >Trækprøve mpa</div>
                        <div style={[styles.colHeading, { display: 'inline-block', width: '12%' }]}>Område</div>
                    </div>
                    {controlAreaNodes}
                </div>
            </div>
        );
    }
}

var styles = {
    outerContainer: {
        margin: '0 0 12px 0',
        paddingRight: '12px'
    },
    container: {
        backgroundColor: greyScaleColors.greyLighter,
        padding: '2px 0 8px 6px',
        margin: '0',
        borderLeft: '2px solid ' + semanticColors.mainBackground
    },
    containerActive: {
        borderLeft: '2px solid ' + semanticColors.info
    },
    containerError: {
        borderLeft: '2px solid ' + semanticColors.danger
    },
    firstColumn: {
    },
    heading: {
        marginBottom: '5px'
    },
    colHeading: {
        fontSize: '12px',
        paddingBottom: '4px',
        textAlign: 'left',
        textOverflow: 'ellipsis',
        paddingLeft: '0'

    }
}


const selectProps = state => {
    return {
        ...state.dailyReportControlAreaReducer
    };
}

export default connect(selectProps)(Radium(ControlAreas));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/ControlArea/controlArea.js